import { render, staticRenderFns } from "./SupplierCreateUpdate.vue?vue&type=template&id=6e8083b0"
import script from "./SupplierCreateUpdate.vue?vue&type=script&lang=js"
export * from "./SupplierCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports